import {
  ItemAttributeOption,
  NumericAspect,
} from "@/models/HomePageSearchResponse";
import _ from "lodash";

const HEIGHT_OPTION_VALUES = _.range(6, 19);

function GenerateHeightOptions(wholeNumberValue: number): NumericAspect[] {
  const results = [];
  for (let fraction = 0; fraction <= 3; fraction += 1) {
    const value = wholeNumberValue + fraction / 10;
    results.push({
      value: value,
      label: `${value} hh`,
    });
  }
  return results;
}

const HEIGHT_OPTIONS: NumericAspect[] = HEIGHT_OPTION_VALUES.flatMap(
  GenerateHeightOptions
);

export default HEIGHT_OPTIONS;

export const HEIGHT_ATTRIBUTE_OPTIONS: ItemAttributeOption[] = _.range(6, 22)
  .flatMap(GenerateHeightOptions)
  .map((height) => ({
    value: height.value.toString(),
    label: height.label,
  }));
